import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import AppLayout from '../AppLayout';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard if user doesn't have access
    const rolePathMap = { super_admin: 'superadmin', school_admin: 'principal' };
    const roleSlug = rolePathMap[user.role] || user.role;
    const dashboardPath = `/${roleSlug}/dashboard`;
    return <Navigate to={dashboardPath} replace />;
  }

  return <AppLayout>{children}</AppLayout>;
};

export default ProtectedRoute;
